export { pushAdClickData } from 'next-flight-server-reference-proxy-loader?id=70eb5e10115bc0759dbabd45fcbb3f373bf658d151&name=pushAdClickData!'